export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_document-notary-hub/artifacts/vrm3m9y0_SmartSelect_20240331_074643_WhatsApp.jpg";

export const BANNER_URL =
  "https://customer-assets.emergentagent.com/job_document-notary-hub/artifacts/6njzwurj_SmartSelect_20240330_201811_WhatsApp.jpg";

export const OWNER_PHOTO =
  "https://customer-assets.emergentagent.com/job_document-notary-hub/artifacts/sbxn7wd4_SmartSelect_20241106_055409_Gallery.jpg";

export const LOGO_BG = "#252C3A";

export const HERO_BG =
  "https://images.unsplash.com/photo-1617170708704-3189ba27e822?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxzb3V0aCUyMGZsb3JpZGElMjBtaWFtaSUyMHNreWxpbmV8ZW58MHx8fHwxNzgzMDg3OTY4fDA&ixlib=rb-4.1.0&q=85";

export const PHONE_DISPLAY = "(866) 923-5462";
export const PHONE_ALT = "(866) 9-ADK-INC";
export const PHONE_TEL = "18669235462";
export const EMAIL = "Adezign@yahoo.com";

export const SERVICES = [
  {
    icon: "FileSignature",
    title: "General Notarizations",
    desc: "Wills, trusts, deeds, power of attorney, and affidavits handled with precision.",
  },
  {
    icon: "Home",
    title: "Real Estate & Loan Signings",
    desc: "Refinances, purchase & seller packets, and HELOCs executed accurately.",
  },
  {
    icon: "Building2",
    title: "Corporate & Business Documents",
    desc: "Contracts, employment verifications, and business agreements.",
  },
  {
    icon: "Stamp",
    title: "Apostille & Certification",
    desc: "International document validation and certification services.",
  },
  {
    icon: "Car",
    title: "Mobile Services",
    desc: "On-site appointments across South Florida — mornings, evenings & weekends.",
  },
];

export const WHY = [
  {
    icon: "ShieldCheck",
    title: "Certified & Bonded",
    desc: "Fully licensed, background-checked, and insured for your peace of mind.",
  },
  {
    icon: "Clock",
    title: "Ultimate Convenience",
    desc: "Skip the traffic and the long lines — we bring the notary to you.",
  },
  {
    icon: "BadgeCheck",
    title: "Accuracy Guaranteed",
    desc: "Meticulous attention to detail ensures flawless execution the first time.",
  },
];

export const HOURS = [
  { day: "Monday", time: "24 Hours" },
  { day: "Tuesday", time: "24 Hours" },
  { day: "Wednesday", time: "7:00 AM – 10:00 AM" },
  { day: "Thursday", time: "7:00 AM – 10:00 AM" },
  { day: "Friday", time: "7:00 AM – 10:00 AM" },
  { day: "Saturday", time: "7:00 AM – 10:00 AM" },
  { day: "Sunday", time: "7:00 AM – 10:00 AM" },
];

export const HOURS_NOTE = "These hours are in effect until November.";

export const SERVICE_OPTIONS = [
  "General Notarization",
  "Real Estate & Loan Signing",
  "Corporate & Business Documents",
  "Apostille & Certification",
  "Marriage Solemnization",
  "Other / Not Sure",
];

export const DOC_CATEGORIES = [
  {
    icon: "Home",
    title: "Real Estate & Property Documents",
    items: [
      "Deeds (Warranty, Quitclaim, Special)",
      "Mortgage documents (applications, agreements, closing packets)",
      "Closing disclosures & settlement documents",
      "Promissory notes for real estate loans",
      "HELOC documents, refinance packages, loan signing packets (if you are a trained signing agent)",
    ],
  },
  {
    icon: "Landmark",
    title: "Financial & Business Documents",
    items: [
      "Powers of Attorney (Durable, Medical, Financial, Limited/General)",
      "Loan agreements & promissory notes (non-real-estate)",
      "Business contracts, agreements, and corporate resolutions (acknowledgments)",
    ],
  },
  {
    icon: "ScrollText",
    title: "Personal Legal Documents",
    items: [
      "Affidavits (general, personal, legal) — sworn statements requiring jurats",
      "Living wills / advance directives",
      "Medical POA documents (often in hospitals or nursing homes)",
      "Divorce settlement agreements (acknowledgments)",
      "Name change documents (when notarization is required)",
    ],
  },
  {
    icon: "BadgeCheck",
    title: "Government & Identity Documents",
    items: [
      "Passport application affidavits (jurats)",
      "DMV forms requiring notarization (bill of sale, VIN verification affidavits)",
      "School forms, permission slips, residency affidavits (acknowledgments)",
    ],
  },
  {
    icon: "FileArchive",
    title: "Estate Planning Documents",
    items: [
      "Wills (only if attorney-prepared; Florida notaries cannot notarize self-prepared wills unless the certificate is correct)",
      "Trust documents",
      "Executor/guardian appointment forms",
    ],
  },
  {
    icon: "Files",
    title: "Miscellaneous Documents",
    items: [
      "Employment verification affidavits",
      "Adoption paperwork requiring notarization",
      "Vehicle title transfers (when notarization is required)",
      "Immigration forms that allow notarization (not legal advice; you cannot give immigration guidance)",
    ],
  },
];

export const OFFICIAL_ACTS = [
  { icon: "Fingerprint", title: "Acknowledgments", desc: "Verifying identity & voluntary signing." },
  { icon: "Gavel", title: "Jurats / Oaths & Affirmations", desc: "Sworn statements." },
  { icon: "Copy", title: "Copy Certifications", desc: "Allowed for certain documents." },
  { icon: "HeartHandshake", title: "Marriage Officiant Services", desc: "Florida notaries can legally solemnize marriages." },
];

export const ADDONS = [
  { title: "Gold Embossed Seal", desc: "Premium presentation." },
  { title: "Silver Embossed Seal", desc: "Executive presentation." },
  { title: "Embossed Seal + Ink Inker", desc: "For photographic reproduction (legal in many states, but please check your state)." },
  { title: "Gold Foil Seals", desc: "Luxury document presentation. 2\" Seal — $50 (includes notary)." },
];

export const ADDON_DISCLAIMER =
  "Florida does not require embossers, but they are allowed as an optional, decorative, fraud-deterrent enhancement. Embossing is optional and decorative — Florida requires an ink stamp as the official notary seal.";
